import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useCustomParamId, useParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiPlus, PiTrash } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { ICashFlowForm } from 'services/cash-flow/types';
import { useGetContractsByLabel } from 'services/contract';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CashFlowContracts = () => {
  const { t } = useTranslation();

  const labelId = useParamId('label');

  const { data } = useGetContractsByLabel(labelId, {
    params: { itemCount: 999, page: 0 },
  });


  const { values, setFieldValue, status, initialValues } =
    useFormikContext<ICashFlowForm>();

  const contractsOptions =
    data?.pages
      .flat()
      .map(e => {
        return {
          value: e.id,
          label: e.title,
        };
      })
      .filter(
        contract =>
          !values.contracts?.some(
            selectedContract => selectedContract.id === contract.value
          )
      ) ?? [];

  return (
    <Table
      id={'CashFlowContracts'}
      size='compact'
      data={{
        nodes: values.contracts
          ? values.contracts?.map((contract, idx) => ({
              index: idx,
              name: contract.name,
              id: contract.id,
            }))
          : [],
      }}
      columns={[
        {
          label: t('label.table.contracts'),
          renderCell: ({ name, id, index }) => (
            <div className='flex justify-between'>
              <FormInput.Select
                options={contractsOptions}
                name={`contracts[${index}].id`}
                value={{
                  label: name,
                  value: id,
                }}
                onChange={newValue => {
                  setFieldValue(`contracts[${index}].name`, newValue.label);
                
                }}
              />
              {status?.displayMode ? undefined : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={() => {
                    setFieldValue(
                      'contracts',
                      values.contracts.filter(c => c.id !== id)
                    );
                  }}>
                  <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </div>
          ),
          resize: true,
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    onClick={() => {
                      setFieldValue(`contracts[${values.contracts.length}]`, {
                        name: '',
                        id: '',
                      });
                    }}>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
    />
  );
};

export default CashFlowContracts;
